import portalProveedoresApi from '../api/portalProveedoresApi'
import authHeader from '../services/auth-header'

const getFacturas = async (Estado, MostrarTodas) => {
  console.log(`GetFacturas - Estado: ${Estado} - MostrarTodas: ${MostrarTodas}`)

  try {
    const { data } = await portalProveedoresApi.post('/GetFacturas', { Email: localStorage.getItem('email'), Estado, MostrarTodas }, { headers: authHeader() })
    console.log('Recibidos datos' + data)
    return data
  } catch (error) {
    console.log(error)
    return { Estado: 'KO' }
  }
}

export default getFacturas
